// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__PdjKH","box":"WorkspacesBox_box__24yA4","node":"WorkspacesBox_node__3GhDu"};